export default __webpack_public_path__ + "static/media/Branded-grey.c11b202b.png";